<template>
  <div class="file-section">
    <div class="file-info">
      <div class="size-allowance">
        <p>{{ sizeLimit }} MB max</p>
      </div>
      <div class="formats">
        <p v-for="(fileType, index) in allowedFileTypes" :key="index">{{ fileType.toUpperCase() }}<span v-show="index < allowedFileTypes.length - 1">,</span></p>
      </div>
    </div>
    <div class="dropzone" :class="getClass" @drop="handleDrop" @dragenter.prevent @dragover.prevent @dragenter="handleDragOver" @dragleave="handleDragEnd">
      <p v-if="files.length === 0">Drag and drop files here.</p>
      <p>{{ fileNames }}</p>
    </div>
    <div v-if="showBackup && !disableFh" class="orBlock">OR</div>
    <input v-if="showBackup && !disableFh" type="file" v-on:change="handleAdd" />
    <p v-for="(error, index) in errors" class="panel-error" :key="index">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      entered: false,
      errors: [],
      disableFh: false
    }
  },
  props: {
    sizeAllowance: {
      type: Number,
      default: 10
    },
    allowedFileTypes: {
      type: Array,
      default: () => ['pdf']
    },
    files: {
      type: Array,
      default: () => []
    },
    singleFileOnly: {
      type: Boolean,
      default: true
    },
    sizeLimit: {
      type: Number,
      default: 10
    },
    showBackup: {
      type: Boolean,
      default: false
    }

  },
  methods: {
    getFileType(fileName) {
      let re = /(?:\.([^.]+))?$/;
      let extension = re.exec(fileName)[1];
      return extension
    },
    handleAdd(e) {
      this.errors = []
      this.entered = false;
      let files = e.target.files;
      this.handleFiles(files);
    },
    handleDrop(e) {
      this.errors = []
      e.preventDefault();
      this.entered = false
      // Check files.
      let files = e.dataTransfer.files
      this.handleFiles(files);

      if (this.showBackup) {
        this.disableFh = true;
      }
    },
    handleFiles(files) {
      if (files.length === 0) this.errors.push('No files were supplied.')
      if (this.singleFileOnly && files.length > 1) this.errors.push('Only 1 file is allowed.')
      let size = 0
      for (let file of files) {
        size += file.size / 1000000
        let fileType = this.getFileType(file.name)
        if (this.allowedFileTypes.indexOf(fileType.toLowerCase()) < 0) this.errors.push(`${fileType.toUpperCase()} not allowed.`)
      }
      if (size > this.sizeLimit) this.errors.push(`File(s) sizes are too large. Please note, we are counting in decimal, not binary for bytes uploaded. Depending on your set up, you may need to go smaller than the limit.`)

      if (this.errors.length > 0) return
      this.$emit('set', files)
    },
    handleDragOver() {
      this.entered = true
    },
    handleDragEnd() {
      this.entered = false
    }
  },
  computed: {
    fileNames() {
      let names = ''
      for (let [i, file] of this.files.entries()) {
        if (i > 0) names += ', '
        names += file.name
      }
      return names
    },
    sizeAllowanceDifference() {
      let size = 0
      for (let file of this.files) {
        size += file.size / 1000000
      }
      return Math.floor((this.sizeAllowance - size) * 100) / 100
    },
    getClass() {
      let className = ''
      if (this.errors.length > 0) className = 'dropzone-error'
      else if (this.entered) className = 'dropzone-entered'
      return className
    }
  }
}
</script>